import {
  FETCH_TRAVEL_PAST_SUMMARY,
  FETCH_TRAVEL_PAST_POI_COUNT,
  FETCH_TRAVEL_PAST_OVER_TIME,
  FETCH_TRAVEL_PAST_DAILY_AVERAGES,
  FETCH_TRAVEL_PAST_POIS,
  FETCH_TRAVEL_PAST_REPEAT_DEVICES,
  LOAD_TRAVEL_PAST_MOCK_DATA,
  SELECT_TRAVEL_PAST_AVERAGE,
  DOWNLOAD_TRAVEL_PAST_INSIGHTS,
  SELECT_TRAVEL_PAST_TIME_PERIOD
} from '../constants';

import travellingPastMockData from '../../data/travellingPastMockData';

export const getTravelPastSummary = () => ({
  type: FETCH_TRAVEL_PAST_SUMMARY,
});

export const getTravelPastPoiCount = () => ({
  type: FETCH_TRAVEL_PAST_POI_COUNT,
});

export const selectTravelPastAverage = selectedAverage => ({
  type: SELECT_TRAVEL_PAST_AVERAGE,
  selectedAverage,
});

export const getTravelPastOverTime = () => ({
  type: FETCH_TRAVEL_PAST_OVER_TIME,
});

export const getTravelPastDailyAverages = () => ({
  type: FETCH_TRAVEL_PAST_DAILY_AVERAGES,
});

export const getTravelPastPois = () => ({
  type: FETCH_TRAVEL_PAST_POIS,
});

export const getTravelPastRepeatDevices = () => ({
  type: FETCH_TRAVEL_PAST_REPEAT_DEVICES,
});

export const loadTravelPastMockData = () => ({
  type: LOAD_TRAVEL_PAST_MOCK_DATA,
  mockData: travellingPastMockData,
});

export const downloadTravelPast  = (csvType,reportType, fileName) => ({
  type: DOWNLOAD_TRAVEL_PAST_INSIGHTS,
  csvType,
  reportType,
  fileName
});

export const selectTravelPastTimePeriod = selectedPeriod =>({
  type: SELECT_TRAVEL_PAST_TIME_PERIOD,
  selectedPeriod,
});
